module.exports = __webpack_public_path__ + "dist/media/nicholas-quinn.657d1e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/team/nicholas-quinn.jpg
// module id = 384
// module chunks = 0